var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame48096008(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#EEFFF6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#EEFFF6",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6654 28L23.4987 26.7917L26.457 23.8333H16.332V22.1667H26.457L23.4987 19.2083L24.6654 18L29.6654 23L24.6654 28Z",
    fill: "#007367"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame48096008);
export default __webpack_public_path__ + "static/media/frame-48096008.582d9d4d2fa8964a2347685237c4b160.svg";
export { ForwardRef as ReactComponent };